import React from "react";
import { Container, Toolbar } from "@material-ui/core";
import ScenarioView from "./ScenarioView";

const ScenariosContainer = () => {
    return (
        <Container>
            <Toolbar sx={{ minHeight: 40 }}/>
            <ScenarioView />
        </Container>
    );
};

export default ScenariosContainer;